import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { httpClient } from '../../services/http';
import { API_ENDPOINTS } from '../../config/api';

type Table = { id: string; name: string; status?: string };

export default function ClientTablesPage() {
  const { restaurantId } = useParams();
  const { user } = useAuth();
  const [tables, setTables] = useState<Table[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedTable, setSelectedTable] = useState<Table | null>(null);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadTables = async () => {
    if (!user?.uid || !restaurantId) return;
    try {
      setLoading(true);
      setError(null);
      const res = await httpClient.get<Table[]>(API_ENDPOINTS.TABLES(user.uid, restaurantId), undefined, 'authenticated');
      setTables(res as any);
    } catch (e) {
      setError('Error cargando mesas');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTables();
  }, [user?.uid, restaurantId]);

  const selectTable = async (table: Table) => {
    if (!user?.uid || !restaurantId) return;
    setSelectedTable(table);
  };

  const createSelection = async () => {
    if (!user?.uid || !restaurantId || !selectedTable) return;
    try {
      setCreating(true);
      await httpClient.post(API_ENDPOINTS.RESERVATION_SELECTION(user.uid, restaurantId), { tableId: selectedTable.id }, 'authenticated');
      alert('Mesa seleccionada. Ahora confirma tu reservación.');
    } catch (e: any) {
      alert(e?.message || 'No se pudo seleccionar la mesa');
    } finally {
      setCreating(false);
    }
  };

  const confirmReservation = async () => {
    if (!user?.uid || !restaurantId || !selectedTable) return;
    try {
      setCreating(true);
      const reservationDate = new Date().toISOString();
      await httpClient.post(API_ENDPOINTS.RESERVATIONS(user.uid, restaurantId), { tableId: selectedTable.id, reservationDate }, 'authenticated');
      alert('Reservación creada (pendiente). El restaurante debe confirmarla.');
      setSelectedTable(null);
    } catch (e: any) {
      alert(e?.message || 'No se pudo crear la reservación');
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#e9ecef] p-4">
      <h2 className="text-xl font-bold text-[#2C4358] mb-3">Mesas</h2>
      {loading && <div>Cargando...</div>}
      {error && <div className="text-red-600">{error}</div>}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {tables.map(t => (
          <button key={t.id} onClick={() => selectTable(t)} className={`p-4 rounded-xl border-2 ${selectedTable?.id === t.id ? 'border-[#22B6B2]' : 'border-[#22B6B2]/30'} bg-white text-[#2C4358]`}>{t.name || t.id}</button>
        ))}
      </div>

      {selectedTable && (
        <div className="mt-5 bg-white p-4 rounded-xl border border-[#22B6B2]/20">
          <div className="font-semibold mb-2">¿Reservar mesa {selectedTable.name || selectedTable.id}?</div>
          <div className="flex gap-2">
            <button disabled={creating} onClick={createSelection} className="px-4 py-2 rounded-lg border-2 border-[#22B6B2]/40">Seleccionar (bloquear)</button>
            <button disabled={creating} onClick={confirmReservation} className="px-4 py-2 rounded-lg bg-[#22B6B2] text-white">Confirmar reservación</button>
            <button disabled={creating} onClick={() => setSelectedTable(null)} className="px-4 py-2 rounded-lg border">Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}


